<app-page title="">
  <div body>
    <form [formGroup]="changePasswordForm" (ngSubmit)="resetPassword()">
      <div class="grid grid-cols-1 gap-y-1 md:grid-cols-1 md:gap-x-16 xl:gap-x-32">

        <app-form label="Old (Current) Password" for="oldPassword" type="text"
          [showError]="changePasswordForm.controls['oldPassword'].invalid && changePasswordForm.controls['oldPassword'].dirty"
          [error]="getErrorMessage('oldPassword')" [mandatory]="true">
          <p-password id="oldPassword" formControlName="oldPassword" placeholder="Old (Current) Password"
            styleClass="mb-2 w-full" inputStyleClass="w-full" class="w-full rounded-md" [toggleMask]="true"
            [feedback]="false"></p-password>
        </app-form>
        <app-form label="New Password" for="newPassword" type="text"
          [showError]="changePasswordForm.controls['newPassword'].invalid && changePasswordForm.controls['newPassword'].dirty"
          [error]="getErrorMessage('newPassword')" [mandatory]="true">
          <p-password id="newPassword" formControlName="newPassword" placeholder="New Password" styleClass="mb-2 w-full"
            inputStyleClass="w-full" class="w-full rounded-md" [toggleMask]="true" [feedback]="false"></p-password>

              @if (changePasswordForm.hasError('oldAndNewPasswordSame')) {
        <div>
          <p class="text-danger pt-1 font-sm ng-star-inserted">
            New password must be different from current password
          </p>
        </div>
}

          <div class="mt-2 text-sm">
            <p class="mb-1 font-semibold">Password Requirements:</p>
            <ul class="list-none p-0 m-0">
              @for (rule of passwordRules; track rule.label) {
              <li [ngClass]="{'text-green-500': rule.valid, 'text-red-500': !rule.valid}"
                class="flex align-items-center mb-1">
                <i [class]="rule.valid ? 'pi pi-check' : 'pi pi-times'" class="mr-2 text-xs"></i>
                {{ rule.label }}
              </li>
              }
            </ul>
          </div>
        </app-form>
  
        <app-form label="Confirm Password" for="confirmPassword" type="text"
          [showError]="changePasswordForm.controls['confirmPassword'].invalid && changePasswordForm.controls['confirmPassword'].dirty"
          [error]="getErrorMessage('confirmPassword')" [mandatory]="true">
          <p-password id="confirmPassword" formControlName="confirmPassword" placeholder="Confirm Password"
            styleClass="mb-2 w-full" inputStyleClass="w-full" class="w-full rounded-md" [toggleMask]="true"
            [feedback]="false"></p-password>
        </app-form>

          @if (changePasswordForm.hasError('passwordMismatch')) {
              <div>
                  <p class="text-danger pt-1 font-sm ng-star-inserted">Passwords do not match</p>
              </div>

          }
  
      </div>
      <div class="flex justify-end p-5">
        <button
          pButton
          type="button"
          label="Close"
          class="p-button-secondary p-button-outlined mr-5"
          (click)="goBack()">
        </button>
        <button pButton type="submit" pRipple label="Submit" [disabled]="changePasswordForm.invalid">
        </button>
      </div>
    </form>
  </div>
</app-page>